import { EventLogger, ICredential, IWebServiceHelperCredentialStore, WebServiceHelper } from '@ViewModels';
import { PersistentStorageManager } from '../models/Storage';
import { BrowserPushNotificationsViewModel } from '../viewmodels/PushNotifications';

/** Simple credential store that honors 'rememberMe' and saves to local storage if needed. */
export class CredentialStore implements IWebServiceHelperCredentialStore {
	private credential: ICredential;
	public getCredential = async () => {
		if (!this.credential) {
			try {
				this.credential = await PersistentStorageManager.local.getObject<ICredential>('credential');
			} catch {
				this.credential = null;
			}
		}
		return Promise.resolve(this.credential);
	};

	public removeCredential = () => {
		this.credential = null;
		return PersistentStorageManager.local.remove('credential');
	};

	public setCredential = (credential: ICredential) => {
		const credentialWithoutPassword = { ...credential };
		delete credentialWithoutPassword.password;
		this.credential = credentialWithoutPassword;
		return PersistentStorageManager.local.setObject('credential', credentialWithoutPassword);
	};

	public clear = () => {
		const credentials = this.credential;

		this.credential = null;

		const settings = BrowserPushNotificationsViewModel.getlocalSettings();

		PersistentStorageManager.local.clear();
		BrowserPushNotificationsViewModel.setLocalSettings(settings);

		this.clearPushSubscription(credentials);
	};

	private async clearPushSubscription(credentials: ICredential) {
		if (!credentials) {
			return;
		}

		const api = new WebServiceHelper({
			baseUrl: import.meta.env.VITE_API_URL,
		});

		const result = await BrowserPushNotificationsViewModel.removeSubscription(api, credentials.user_id, credentials);
		if (result.success) {
			const settings = BrowserPushNotificationsViewModel.getlocalSettings();

			if (settings && !settings[credentials.user_id]?.inactive) {
				delete settings[credentials.user_id];
				await BrowserPushNotificationsViewModel.setLocalSettingsAsync(settings);
			}
			return;
		}

		if (result.systemCode === 401) {
			// Can happen if tab is left open, auth token expires, and user clicks log out as first action on return to the page.
			return;
		}
		EventLogger.logEvent({ action: 'Unsubscribe-Error', category: 'PushNotifications' }, { ...result });
	}
}
